import VueOnsen from 'vue-onsenui';

// VueOnsenの設定を行う関数
const setupVueOnsen = () => {
  VueOnsen.disableAutoStyling(); // Auto Styling を無効化
  return VueOnsen; // 設定したインスタンスを返す
};

const ons = setupVueOnsen();

export default ons;
